import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoaderService } from '@axon/data-access-lib';
import { Observable } from 'rxjs';

@Component({
    selector: 'ado-core-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
    loaderEnabled$: Observable<boolean>;

    constructor(public loaderService: LoaderService) {
        this.loaderEnabled$ = loaderService.loaderEnabled;
    }
}
